module.exports = __webpack_public_path__ + "img/story-title-icon-1.af5ea14f.png";